// extracted by mini-css-extract-plugin
export var arrow = "_2v-6";
export var changeItem = "_2v-3";
export var changesHeader = "_2v-1";
export var changesList = "_2v-2";
export var container = "_2v-0";
export var pathLabel = "_2v-4";
export var value = "_2v-7";
export var valuesContainer = "_2v-5";